import { useAssistantDock } from '../plan/useAssistantDock'
import { Icon } from './Icon'

// AssistantLauncher — the way into the conversation from anywhere, living in the
// top bar beside Search and Help.
//
// It used to be a pill floating at the bottom-right of the page, which meant it
// was always over SOMETHING: three readings running reported it cutting the
// count column off list rows on Inbox and Aesthetics — "the one helpful element
// on those screens was eating their content". A fixed overlay cannot be padded
// out of the way, because content scrolls underneath it. Global actions already
// have a home; this is one.
export function AssistantLauncher() {
  const { dock, setMode } = useAssistantDock()
  const open = dock.mode === 'float' || dock.mode === 'right'
  return (
    <button
      className={`assistant-launch${open ? ' on' : ''}`}
      aria-pressed={open}
      onClick={() => setMode(open ? 'closed' : 'float')}
      title={open ? 'Close the assistant' : 'Open the assistant'}
    >
      <Icon name="questions" size={15} />
      <span>Assistant</span>
    </button>
  )
}
